import { AfterViewInit, Directive, ElementRef, OnDestroy, inject, input, output } from '@angular/core';
import {throttleTime} from "rxjs/operators";
import {fromEvent} from "rxjs";
import type { Subscription} from "rxjs";

@Directive({
    selector: '[appInfiniteScroll]',
    standalone: false
})
export class InfiniteScrollDirective implements AfterViewInit, OnDestroy{
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);


  readonly lockBeforeReset = input<boolean>(undefined);
  readonly lockBottom = input<boolean>(undefined);
  readonly distance = input<number>(undefined);
  readonly throttle = input<number>(undefined);
  readonly onScroll = output();

  private sub: Subscription;
  private lastTopScroll: number;
  private scrollDirection: number; //1 bottom 0 up
  private lastPercentage: number;
  private locked = false;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  ngAfterViewInit() {
    this.sub = fromEvent(this.elementRef.nativeElement, 'scroll').pipe(throttleTime(this.throttle())).subscribe(() => {
      const element = this.elementRef.nativeElement;
      const percentage = element.scrollTop / (element.scrollHeight - element.clientHeight) * 10;

      this.scrollDirection = element.scrollTop > this.lastTopScroll ? 1 : 0;

      let lockedPercentage = false;

      if(this.lastPercentage != null && percentage > this.lastPercentage && this.locked) {
        lockedPercentage = true;
      } else
        this.locked = false;

      if(percentage >= 10 - this.distance() && this.checkPercentage(lockedPercentage) && this.checkBottom()) {
        this.onScroll.emit();
        this.locked = true;
      }

      this.lastTopScroll = element.scrollTop;
      this.lastPercentage = percentage;
    });

  }

  checkBottom() {
    return !this.lockBottom() ? true : this.scrollDirection;
  }

  checkPercentage(param) {
    return !this.lockBeforeReset() ? true : !param;
  }

  ngOnDestroy() {
    this.sub.unsubscribe()
  }

}
